// extracted by mini-css-extract-plugin
export var card = "staffDirectory-module--card--f65b1";
export var image_wrap = "staffDirectory-module--image_wrap--9dea8";
export var name = "staffDirectory-module--name--d450c";
export var staff_directory = "staffDirectory-module--staff_directory--93474";
export var staff_list = "staffDirectory-module--staff_list--79d03";
export var team = "staffDirectory-module--team--a1678";
export var title = "staffDirectory-module--title--9fe86";